import { useMemo } from "react";
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import cn from "../../../utils/cn";
import "./BarLoader.css";
import { jsx as _jsx } from "react/jsx-runtime";
const BarLoader = _ref => {
  let {
    tall = false,
    className = "",
    id = "",
    size = "full",
    style = {}
  } = _ref;
  const barLoaderClass = useMemo(() => {
    return cn({
      "gradient-animation": true,
      "w-1/4": isEqual("quarter", size),
      "w-1/2": isEqual("half", size),
      "w-3/4": isEqual("semi-full", size),
      "w-full": !isEqual("quarter", size) && !isEqual("half", size) && !isEqual("semi-full", size),
      "h-9": tall,
      "h-4": !tall
    }, className);
  }, [tall, size, className]);
  return /*#__PURE__*/_jsx("div", {
    id: id,
    style: style,
    className: barLoaderClass
  });
};
BarLoader.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  tall: PropTypes.bool,
  size: PropTypes.oneOf(["quarter", "half", "semi-full", "full"]),
  style: PropTypes.object
};
export default BarLoader;
//# sourceMappingURL=BarLoader.js.map